/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Previous_DifferenceInputs */



/**
* | output |
* | --- |
* | "Previous Difference" |
*
* @param {Compare_Event_Groups_Previous_DifferenceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_previous_difference = /** @type {((inputs?: Compare_Event_Groups_Previous_DifferenceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Previous_DifferenceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Différence précédente")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorherige Differenz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Differenza precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предыдущая разница")
	if (locale === "es") return /** @type {LocalizedString} */ ("Diferencia anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("先前差异")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前回の差異")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछला अंतर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diferença anterior")
	return /** @type {LocalizedString} */ ("Previous Difference")
});